import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosInstance } from "../../../common/utils/AxiosInstance";
import CryptoJS from "crypto-js";
import { HMAC_SECRET_KEY } from "../../../config/api.config";

export const signup = createAsyncThunk(
   "signup",
   async (data, { rejectWithValue }) => {
      const URL = "user/profile"
      const token = JSON.parse(localStorage.getItem("token"))
      const bodyJson = JSON.stringify(data);
      const hmac = CryptoJS.HmacSHA256(
         bodyJson,
         HMAC_SECRET_KEY
      ).toString();
      try {
         const res = await AxiosInstance.post(URL, data, {
            headers: {
               "x-auth-token": token,
               "x-signature": hmac,
            }
         })
         return { response: JSON.parse(JSON.stringify(res)) }
      } catch (error) {

         return JSON.parse(JSON.stringify(rejectWithValue(error)))
      }
   }
)

export const partnerSignup = createAsyncThunk(
   "partnerSignup",
   async (data, { rejectWithValue }) => {
      const URL = "user/profile"
      const token = JSON.parse(localStorage.getItem("token"))
      const bodyJson = JSON.stringify(data);
      const hmac = CryptoJS.HmacSHA256(
         bodyJson,
         HMAC_SECRET_KEY
      ).toString();

      try {
         const res = await AxiosInstance.post(URL, data, {
            headers: {
               "x-auth-token": token,
               "x-signature": hmac,
            }
         })

         return { response: JSON.parse(JSON.stringify(res)) }
      } catch (error) {

         return JSON.parse(JSON.stringify(rejectWithValue(error)))
      }
   }
)